import {basicInfo, accessList} from '@configs/basicInfomationConfig'
export const __DEV__ = window.location.hostname === 'localhost'
export const __TESTING__ = window.location.hostname === 'amrak-dev-sms.unicloud360.com'
export const __STAGING__ = window.location.hostname === 'apiit-sms-staging.ceyentra.lk'
// export const __PROD__ = window.location.hostname === 'apiit-sms-prod.ceyentra.lk'
export const __PROD__ = window.location.hostname === 'sms.amrak.lk'
import config from '@storage'

export const DOC_PDF = require('@src/assets/images/student/doc.png').default
export const DEFAULT_AVATAR = require('@src/assets/images/portrait/avatar-blank.png').default
export const EMPTY_FILE = require('@src/assets/images/counsellor/emptyFile.png').default
export const DEFAULT_RECOMMENDATION_LETTER = require('@src/assets/images/counsellor/letter.png').default
export const DEFAULT_RECOMMENDATION_LETTER_DARK = require('@src/assets/images/counsellor/letter-dark.png').default
export const DEFAULT_STUDENT_AGREEMENT = require('@src/assets/images/counsellor/agreement.png').default
export const DEFAULT_QUALIFICATION_RESULT_SHEET = require('@src/assets/images/counsellor/resultSheet.png').default
export const DEFAULT_QUALIFICATION_OTHER_ATTACHMENTS = require('@src/assets/images/counsellor/otherAttachment.png').default
export const FAVICON_ICON = require('@src/assets/images/logo/logo-icon.png').default
export const FAVICON_WHITE_ICON = require('@src/assets/images/logo/favicon-white.png').default
export const COUNSELLOR_DECLARATION = 'I, hereby declare and confirm the accuracy and truthfulness of the facts that I have herein disclosed or mentioned; if any of the facts disclosed herein shall become false or inaccurate, I accept to be prosecuted and punished under the quarantine rules and regulations of Sri Lanka.'
export const COURSE_TRANSFER_DECLARATION = '1. I declare that all the particulars provided in this form are complete and correct.\n' +
    '2. I undertake to pay all fees by the due date and to pay the administrative charge for late payments (late payment fee) where necessary as stipulated in the Fees and Enrolment Guide.\n' +
    '3. I understand that I will not be permitted to use Amrak facilities if payments are not made on the due date and that my studentship/ student status is subject to cancellation if the payment of fees is delayed by 45 days.\n' +
    '4. I have read and understood Amrak refund policy which is stated in the Fees and Enrolment Guide.\n' +
    '5. I agree to abide by Amrak Professional Code of Conduct as stated in the Student Handbook.'
export const IDENTIFIERS = ['Mr', 'Mrs', 'Miss', 'Dr']
export const STUDENT_ONBOARD_TOKEN = '/student-onboard/3f078484b1189f734d15e0f6de015a37970c18f76296cd3dcbd03853b5455a9c'
export const INQUIRY_TYPES = [
    {label: 'Phone In', value: 'PHONE_IN'},
    {label: 'Direct Phone-In', value: 'DIRECT_PHONE_IN'},
    {label: 'E-Mail', value: 'EMAIL'},
    {label: 'Walk-in', value: 'WALK_IN'},
    {label: 'FB Lead', value: 'FB_LEAD'},
    {label: 'Exhibition', value: 'EXHIBITION'},
    {label: 'Friends', value: 'FRIENDS'},
    {label: 'Hotline', value: 'HOTLINE'},
    {label: 'Open Day', value: 'OPEN_DAY'},
    {label: 'SIS', value: 'SIS'},
    {label: 'School Promotion', value: 'SCHOOL_PROMOTION'},
    {label: 'Univisitor', value: 'UNIVISITOR'},
    {label: 'Website', value: 'WEBSITE'},
    {label: 'Agent', value: 'AGENT'},
    {label: 'Database', value: 'DATABASE'}
]
export const FEE_TYPES = [
    {label: 'Registration Fee', value: 'REGISTRATION_FEE'},
    {label: 'Library Fee', value: 'LIBRARY_FEE'},
    {label: 'SU Fee', value: 'SU_FEE'},
    {label: 'Exemption Fee', value: 'EXEMPTION_FEE'},
    {label: `${basicInfo.courseLabel} Fee`, value: 'COURSE_FEE'}
]
export const INQUIRY_STATUS = [
    {label: 'All', value: null},
    {label: 'Inquiry', value: 'INQUIRY'},
    {label: 'Followup', value: 'FOLLOWUP'},
    // {label: 'Application Shared', value: 'APPLICATION_SHARED'},
    // {label: 'Application Submitted', value: 'APPLICATION_SUBMITTED'},
    // {label: 'HOS Approval', value: 'HOS_APPROVAL'},
    // {label: 'HOA Approval', value: 'HOA_APPROVAL'},
    // {label: 'Offer Letter Shared', value: 'OFFER_LETTER_SHARED'},
    // {label: 'Course Details Shared', value: 'COURSE_DETAILS_SHARED'},
    // {label: 'Pending Payment', value: 'PENDING_PAYMENT'},
    {label: 'Not Interested', value: 'NOT_INTERESTED'},
    // {label: 'Enrollment', value: 'ENROLLMENT'},
    {label: 'Registration', value: 'REGISTRATION'},
    {label: 'Future Intake', value: 'FUTURE_INTAKE'},
    {label: 'Unassigned', value: 'UNASSIGNED'},
    {label: 'Rejected', value: 'REJECTED'}
]

export const NOTIFY_TO_HOC_STATUS = [
    {label: 'All', value: null},
    {label: 'Notified', value: 'NOTIFIED'},
    {label: 'Not Notified', value: 'NOT_NOTIFIED'}
]

export const INQUIRY_PROSPECT_STATUS = [
    {label: 'Followup', value: 'FOLLOWUP'},
    {label: 'Future Intake', value: 'FUTURE_INTAKE'},
    {label: 'Not Interested', value: 'NOT_INTERESTED'}
]
export const INQUIRY_PROSPECT_STATUS2 = [
    {label: 'Followup', value: 'FOLLOWUP'},
    {label: 'Not Interested', value: 'NOT_INTERESTED'}
]
export const INTAKES = [
    {intakeId: 0, intakeCode: 'ABC-2314'},
    {intakeId: 1, intakeCode: '20211012'},
    {intakeId: 2, intakeCode: 'GDSE-45'},
    {intakeId: 3, intakeCode: 'ABC-4321'}
]
export const LEVELS = [
    {levelId: 0, levelName: 'Level 1'},
    {levelId: 1, levelName: 'Level 2'},
    {levelId: 2, levelName: 'Level 3'},
    {levelId: 3, levelName: 'Level 4'}
]
export const COUNSELLORS = [
    {userId: 0, firstName: 'Udara', lastName: 'Prabath'},
    {userId: 1, firstName: 'Test', lastName: 'User'}
]
export const COURSES = [
    {courseId: 0, courseName: 'Bachelor of Design'},
    {courseId: 1, courseName: 'Bachelor of Science'}
]
export const COURSE_MODULES = [
    {moduleId: 0, moduleName: "IT Management", credits: 2, isCore: true},
    {moduleId: 1, moduleName: "Java Programing", credits: 2, isCore: true},
    {moduleId: 2, moduleName: "Network Security", credits: 2, isCore: true},
    {moduleId: 3, moduleName: "C# Programing", credits: 2, isCore: false},
    {moduleId: 4, moduleName: "Web Development", credits: 2, isCore: false},
    {moduleId: 5, moduleName: "Data Science", credits: 2, isCore: false}
]
export const MARKETING_CODES = [
    {label: "Alfaa Bursary", value: "ALFAA_BURSARY"},
    // {label: "Apiit Social media", value: "APIIT_SOCIAL_MEDIA"},
    // {label: "Apiitian", value: "APIITIAN"},
    // {label: "Apiitizer", value: "APIITIZER"},
    {label: "Branding", value: "BRANDING"},
    {label: "Corporate Promotion", value: "CORPORATE_PROMOTION"},
    {label: "Daily Ft", value: "DAILY_FT"},
    {label: "Dinamina", value: "DINAMINA"},
    {label: "Direct Mailers", value: "DIRECT_MAILERS"},
    {label: "Edex", value: "EDEX"},
    {label: "Email Campaign", value: "EMAIL_CAMPAIGN"},
    {label: "Exhibition", value: "EXHIBITION"},
    {label: "Family", value: "FAMILY"},
    {label: "Hotline", value: "HOTLINE"},
    {label: "Open Day", value: "OPEN_DAY"},
    {label: "Orientation", value: "ORIENTATION"},
    {label: "Press - Daily Mirror", value: "PRESS_DAILY MIRROR"},
    {label: "Press - Veerakesari", value: "PRESS_VEERAKESARI"},
    {label: "Press - Lankadeepa", value: "PRESS_LANKADEEPA"},
    {label: "Press - Daily News", value: "PRESS-DAILY NEWS"},
    {label: "Press - Lakbima", value: "PRESS_LAKBIMA"},
    {label: "Press - Observer", value: "PRESS_OBSERVER"},
    {label: "Press - Sunday Times", value: "PRESS_SUNDAY_TIMES"},
    {label: "Press - Sunday Leader", value: "PRESS_SUNDAYLEADER"},
    {label: "Scholarship", value: "SCHOLARSHIP"},
    {label: "Sis", value: "SIS"},
    {label: "Special Promotion", value: "SPECIAL_PROMOTION"},
    // {label: "Apiit Staff Member", value: "APIIT_STAFF_MEMBER"},
    {label: "Tv Program", value: "TV_PROGRAM"},
    {label: "Through Friends", value: "THROUGH_FRIENDS"},
    {label: "Univiser", value: "UNIVISER"},
    {label: "Web Site", value: "WEB_SITE"},
    {label: "Magazine", value: "MAGAZINE"},
    {label: "Other", value: "OTHER"}
]
export const HOBBIES = [
    {label: 'Playing Games -  Indoor', value: 'Playing Games -  Indoor'},
    {label: 'Watching TV Series/ Movies', value: 'Watching TV Series/ Movies'},
    {label: 'App.test.js', value: 'App.test.js'},
    {label: 'Reading Books', value: 'Reading Books'}
]
export const SOCIAL_MEDIA = [
    {label: 'FaceBook', value: 'FaceBook'},
    {label: 'Instagram', value: 'Instagram'},
    {label: 'Twitter', value: 'Twitter'},
    {label: 'Snapchat', value: 'Snapchat'},
    {label: 'Youtube', value: 'Youtube'},
    {label: 'LinkedIn', value: 'LinkedIn'},
    {label: 'TikTok', value: 'TikTok'}
]
export const INCOME = [
    {label: '0 - 50,000', value: '0 - 50,000'},
    {label: '50,000 - 150,000', value: '50,000 - 150,000'},
    {label: '150,000-250,000', value: '150,000-250,000'},
    {label: '250,000 - 500,000', value: '250,000 - 500,000'},
    {label: 'Above 500,000', value: 'Above 500,000'}
]
export const EXPERIENCE = [
    {label: 'Below 1 year', value: 'Below 1 year'},
    {label: '2 - 5 Years', value: '2 - 5 Years'},
    {label: 'Above 5 Years', value: 'Above 5 Years'}
]
export const COURSES_APPLIED = [
    {
        courseId: 0,
        courseName: "BBS - Bachelor of Business Studies",
        electiveModules: [1, 3, 6, 8],
        studyMode: "WEEKEND",
        remark: "Testing remark",
        recommendationLetter: "image",
        studentAgreement: null,
        intakeId: 1,
        intakeCode: '20210101',
        status: "PENDING"
    },
    {
        courseId: 1,
        courseName: "BSc. Computer Science",
        electiveModules: [1, 3, 6, 8],
        studyMode: "WEEKEND",
        remark: "Testing remark",
        recommendationLetter: "image",
        studentAgreement: null,
        intakeId: 5,
        intakeCode: '20210101',
        status: "PENDING"
    }
]
export const COURSE_APPLIED_REMARKS = [
    {
        remarkId: 0,
        recommendation: "Recommended",
        courseName: "Integrated Law Course- BA + LL.B",
        remark: "Et laoreet sit molestie arcu in in placerat tempus in.",
        remarkDate: "2022/12/12",
        feedback: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Euismod ipsum at.",
        userName: "Dr.Nihal Wimalasooriya",
        UserRole: "Head of the Department"
    },
    {
        remarkId: 1,
        recommendation: "Rejected",
        courseName: "BBS- Bachelor of Business Studies",
        remark: "Et laoreet sit molestie arcu in in placerat tempus in.",
        remarkDate: "2022/12/12",
        feedback: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Euismod ipsum at.",
        userName: "Dr.Nihal Wimalasooriya",
        UserRole: "Head of the Department"
    }
]
export const OFFER_LETTERS = [
    {
        label: 'Offer Letter',
        value: 1,
        conditional: true
    },
    {
        label: 'Offer Letter',
        value: 2,
        conditional: false
    },
    {
        label: 'Offer Letter (Part Time)',
        value: 3,
        conditional: true
    }
]

export const CUSTOM_DISCOUNT_TYPES = [
    {label: 'Not Applied', value: 'NONE', color: 'light-secondary'},
    {label: 'Pending FE Approval', value: 'PENDING_FE_APPROVAL', color: 'light-warning'},
    {label: 'FE Rejected', value: 'FE_REJECTED', color: 'light-danger'},

    {label: 'FE Approved', value: 'FE_APPROVED', color: 'light-success'},
    {label: 'Pending FM Approval', value: "SEND_TO_FM", color: 'light-warning'},
    {label: 'Pending HOF Approval', value: "SEND_TO_HOF", color: 'light-warning'},

    {label: 'FE Rejected', value: "FE_REJECTED", color: 'light-danger'},
    {label: 'FM Rejected', value: "FM_REJECTED", color: 'light-danger'},
    {label: 'HOF Rejected', value: "HOF_REJECTED", color: 'light-danger'},
    {label: 'FE Approved', value: "FE_APPROVED", color: 'light-success'},
    {label: 'FM Approved', value: "FM_APPROVED", color: 'light-success'},
    {label: 'HOF Approved', value: "HOF_APPROVED", color: 'light-success'}
]

export const DISCOUNT_TYPES = [
    {typeId: 0, name: 'Discount type 1'},
    {typeId: 1, name: 'Discount type 2'}
]
export const PAYMENT_PLAN = [
    {description: 'Registration Fee 2021 ', feeType: 'Registration Fee', dueDate: '01/01/2021', amount: '50,000.00'},
    {
        description: '50% off early bird discount',
        feeType: 'Early Bird Discount',
        dueDate: '01/01/2021',
        amount: '50,000.00'
    },
    {description: 'Library Fee 2021', feeType: 'Library Fee', dueDate: '01/01/2021', amount: '50,000.00'}
]
export const FOLLOW_UPS = [
    {
        followUpId: 0,
        date: '01/01/2021',
        counsellorId: 1,
        counsellorName: 'Rohana De Mel',
        intakeId: 1,
        intakeCode: '2021 FT Oct IT',
        nextFollowUp: '02/02/2021',
        status: 'FUTURE_INTAKE',
        time: '02.30 PM',
        remark: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Euismod ipsum at.'
    }
]
export const FOLLOW_UP_STATUS = ['FOLLOW_UP', 'NOT_INTERESTED', 'FUTURE_INTAKE', 'REJECTED']
export const INQUIRY_PROSPECT_ACTIONS = ['ADD', 'VIEW', 'EDIT']
export const GENDER = ['MALE', 'FEMALE']
export const MARITAL_STATUS = ['SINGLE', 'MARRIED']
export const LOCALITY = ['LOCAL', 'FOREIGN']
export const FILE_TYPES = ['NIC', 'RESUME', 'PROFILE_IMAGE', 'SERVICE_LETTER', "COURSE_RECOMMENDATION_LETTER", "COURSE_STUDENT_AGREEMENT", "QUALIFICATION_TRANSCRIPT", "QUALIFICATION_DOCUMENT", "COURSE_DETAILS_SHARE_DOCUMENTS", "SPECIAL_APPROVE_SEND_TO_AA", "INQ_EXEMPTION"]
export const API_RESPONSE_STATUS = [0, 1]
export const COURSE_DETAILS_SHARE = ['REGISTRATION_LINK', 'COURSE_DETAILS', 'REG_AND_COURSE']
export const GUR_ADDRESS = ['STUDENT_RESIDENTIAL', 'STUDENT_PERMANENT', 'OTHER']
export const CSV_HEADER = [
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Inquiry Status", key: "inquiryStatus"},
    {label: "Intake Id", key: "intakeId"},
    {label: "Inquiry Type", key: "inquiryType"},
    {label: "Remark", key: "remark"},
    {label: "Organization Email", key: "orgEmail"},
    {label: "Counsellor Id", key: "userId"}
]

export const ALL_INQUIRIES_CSV_HEADER = [
    {label: "Inq No.", key: "inquiryId"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Inquiry Type", key: "inquiryType"},
    {label: "Inquiry Date", key: "inquiryDate"},
    {label: "Counsellor Name", key: "counselorName"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"},
    {label: "Marketing Code", key: "marketingCode"},
    {label: "Intake Code", key: "intakeCode"},
    {label: "Status", key: "status"}
]

export const MY_INQUIRIES_CSV_HEADER = [
    {label: "InquiryNumber", key: "inquiryNumber"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Inquiry Type", key: "inquiryType"},
    {label: "Inquiry Date", key: "inquiryDate"},
    {label: "Counsellor Name", key: "counselorName"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"},
    {label: "Marketing Code", key: "marketingCode"},
    {label: "Intake Code", key: "intakeCode"}
]

export const MY_INQUIRIES_TEMPLATE_CSV_HEADER = [
    {label: "studentName", key: "studentName"},
    {label: "studentMobile", key: "studentMobile"},
    {label: "inquiryStatus", key: "inquiryStatus"},
    {label: "intakeId", key: "intakeId"},
    {label: basicInfo.courseId, key: basicInfo.courseId},
    {label: "inquiryType", key: "inquiryType"},
    {label: "remark", key: "remark"},
    {label: "orgEmail", key: "orgEmail"},
    {label: "counselorId", key: "counselorId"},
    {label: "date", key: "date"}
]
export const UNASSIGNED_INQUIRIES_TEMPLATE_CSV_HEADER = [
    {label: "studentName", key: "studentName"},
    {label: "studentMobile", key: "studentMobile"},
    {label: "studentEmail", key: "studentEmail"},
    {label: "remark", key: "remark"}
]
export const MARK_ATTENDANCE_TEMPLATE_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "studentName", key: "studentName"},
    {label: "remark", key: "remark"},
    {label: "batchCode", key: "batchCode"},
    {label: "present", key: "present"},
    {label: "absent", key: "absent"},
    {label: "late", key: "late"}
]
export const MARK_ATTENDANCE_EXPORT_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "studentName", key: "studentName"},
    {label: "remark", key: "remark"},
    {label: "batchCode", key: "batchCode"},
    {label: "presence", key: "presence"}
]
export const MARK_ATTENDANCE_SUMMARY_EXPORT_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "studentName", key: "studentName"},
    {label: "batch", key: "batch"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "courseCode", key: "courseCode"},
    {label: "avg", key: "avg"}
]

export const STUDENT_ASSESSMENTS_EXPORT_CSV_HEADERS = [
    {label: "Level Name", key: "levelName"},
    {label: "Semester", key: "semesterName"},
    {label: "Module Name", key: "moduleName"},
    {label: "Assessment", key: "assessmentName"},
    {label: "Assessment Type", key: "assessmentType"},
    {label: "Submission Date", key: "submissionDate"},
    {label: "Weightage", key: "weightage"}
]

export const ALL_FOLLOWUP_CSV_HEADER = [
    {label: "InquiryNumber", key: "inquiryNumber"},
    {label: "Remark", key: "remark"},
    {label: "StudentName", key: "studentName"},
    {label: "StudentMobile", key: "studentMobile"},
    {label: "StudentEmail", key: "studentEmail"},
    {label: "InquiryType", key: "inquiryType"},
    {label: "NextFollowupDate", key: "nextFollowupDate"},
    {label: "CounselorName", key: "counselorName"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"},
    {label: "AppointmentDate", key: "appointmentDate"},
    {label: "LastFollowupDate", key: "lastFollowupDate"}
]

export const ENROLLMENT_CSV_HEADER = [
    {label: "inquiryNumber", key: "inquiryNumber"},
    {label: "studentName", key: "studentName"},
    {label: "studentMobile", key: "studentMobile"},
    {label: "studentEmail", key: "studentEmail"},
    {label: "counselorName", key: "counselorName"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"},
    {label: "apiitReferenceNumber", key: "apiitReferenceNumber"},
    {label: "requestedDate", key: "requestedDate"}
]

export const REGISTRATION_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "studentName", key: "studentName"},
    {label: "dateOfBirth", key: "dateOfBirth"},
    {label: "address", key: "address"},
    {label: "studentContact", key: "studentContact"},
    {label: "studentEmail", key: "studentEmail"},
    {label: "personalEmail", key: "personalEmail"},
    {label: "registeredAward", key: "courseName"},
    {label: "batchCode", key: "batchCode"},
    {label: "gender", key: "gender"},
    {label: "registeredDate", key: "registeredDate"},
    {label: "counselorName", key: "counselorName"},
    {label: "intake", key: "intake"},
    {label: "paymentPlan", key: "paymentPlan"},
    {label: "paymentCollectedBy", key: "paymentCollectedBy"},
    {label: "qualifications", key: "qualifications"}
]

export const STUDENT_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Student Name", key: "studentName"},
    {label: "dateOfBirth", key: "dateOfBirth"},
    {label: "address", key: "address"},
    {label: "Contact", key: "studentMobile"},
    {label: "Email", key: "studentEmail"},
    {label: "personalEmail", key: "personalEmail"},
    {label: "registeredAward", key: "courseName"},
    {label: "batchCode", key: "batchCode"},
    {label: "gender", key: "gender"},
    {label: basicInfo.courseLabel, key: "courseName"},
    {label: "Batch", key: "batchCode"},
    {label: "Uni Id", key: "uniId"},
    {label: "qualifications", key: "qualifications"}
]

export const PENDING_QUALIFICATION_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "StudentName", key: "studentName"},
    {label: "StudentContact", key: "studentContact"},
    {label: "StudentEmail", key: "studentEmail"},
    {label: "RegisteredDate", key: "registeredDate"},
    {label: "Qualification", key: "qualification"},
    {label: "Results", key: "results"},
    {label: basicInfo.schoolLabel, key: "school"},
    {label: "Year", key: "year"},
    {label: "Index No", key: "indexNo"},
    {label: "Transcript", key: "transcript"},
    {label: "Other Attachment", key: "otherAttachment"}
]

export const SUBMITTED_APPLICATION_CSV_HEADER = [
    {label: "InquiryId", key: "inquiryId"},
    {label: "StudentName", key: "studentName"},
    {label: "StudentMobile", key: "studentMobile"},
    {label: "StudentEmail", key: "studentEmail"},
    {label: "InquiryType", key: "inquiryType"},
    {label: "RequestedDate", key: "requestedDate"},
    {label: "CounselorName", key: "counselorName"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"}
]

export const NOT_INTERESTED_CSV_HEADER = [
    {label: "Inquiry Number", key: "inquiryNumber"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Inquiry Type", key: "inquiryType"},
    {label: "Last Followup Date", key: "lastFollowupDate"},
    {label: "Counselor Name", key: "counselorName"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"},
    {label: "Remark", key: "followUpRemark"}
]

export const PENDING_PAYMENT_CSV_HEADER = [
    {label: "Inquiry Id", key: "inquiryId"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Counselor Name", key: "counselorName"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"},
    {label: "Registration Due Date", key: "requestedDate"},
    // {label: "apiitReferenceNumber", key: "apiitReferenceNumber"},
    {label: "Payment Plan", key: "paymentPlan"},
    {label: "Remark", key: "remark"}
]

export const FUTURE_INTAKE_CSV_HEADER = [
    {label: "Inquiry Number", key: "inquiryNumber"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Intake", key: "intake"},
    {label: "Inquiry Type", key: "inquiryType"},
    {label: "Counselor Name", key: "counselorName"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"},
    {label: "Last Followup Date", key: "lastFollowupDate"},
    {label: "Remark", key: "followUpRemark"}
]

export const HOA_APPROVAL_CSV_HEADER = [
    {label: "inquiryId", key: "inquiryId"},
    {label: "studentName", key: "studentName"},
    {label: "studentMobile", key: "studentMobile"},
    {label: "studentEmail", key: "studentEmail"},
    {label: "counselorName", key: "counselorName"},
    {label: "courseName", key: "courseName"},
    {label: "approvedDate", key: "approvedDate"},
    {label: "remark", key: "remark"},
    {label: "subStatus", key: "subStatus"},
    {label: "apiitReferenceNumber", key: "apiitReferenceNumber"},
    {label: "approvedBy", key: "approvedBy"}
]

export const BANK_TRANSFER_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNo"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Request Date", key: "requestDate"},
    {label: "Status", key: "status"},
    {label: "Counsellor Name", key: "counselorName"},
    {label: "Course Name", key: "courseName"},
    // {label: "Discounts", key: "discounts"},
    {label: "Intake Code", key: "intakeCode"},
    {label: "Deposit Date", key: "depositDate"},
    {label: "Fee Type", key: "feeType"},
    {label: "Amount", key: "amount"}
]

export const COLOR_STATUS = ['success', 'danger', 'warning', 'info', 'dark', 'primary', 'secondary', 'purple']
export const COURSE_APPLIED_STATUS = ["PENDING", "ENROLLED", "REJECTED", "NONE", "RECOMMENDED", "DECLINED"]
export const HOA_APPROVALS_STATUS = ["PENDING", "APPROVED", "REJECTED"]
export const SPECIAL_APPROVAL_STATUS = ["PENDING", "APPROVED", "REJECTED"]
export const HOS_SPECIAL_APPROVAL_STATUS = ["SEND_TO_HOS", "HOS_RECOMMENDED", "HOS_REJECTED", "AA_RECOMMENDED", "AA_REJECTED", "FM_RECOMMENDED", "FM_REJECTED", "HOF_RECOMMENDED", "HOF_REJECTED", "SEND_TO_AA", "SEND_TO_HOF", "SEND_TO_FM"]
export const SPECIAL_APPROVAL_CURRENT_STATUS = ["AA_APPROVED", "AA_REJECTED", "SEND_TO_AA"]
export const COURSE_APPLIED_MODAL_ACTION = ["ADD", "EDIT"]
export const SPECIAL_APPROVAL_MODAL_ACTION = ["ADD", "VIEW", "EDIT"]
export const QUALIFICATION_APPLIED_MODAL_ACTION = ["ADD", "EDIT"]
export const STUDY_MOOD = ["WEEK_DAYS", "WEEKEND"]
export const TARGET_TYPE = ["GROUP", "INDIVIDUAL"]
export const OFFER_TYPE = ["CONDITIONAL", "UNCONDITIONAL", "ALL"]
export const CURRENCY = ["LKR", "USD"]
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_FORMAT_2 = 'YYYY/MM/DD'
export const DATE_FORMAT_H = 'YYYY-MM-DD HH-MM'
export const DATE_FORMAT_H2 = 'YYYY-MM-DD HH:MM'
export const DATE_FORMAT_TABLE = 'DD/MM/YYYY'
export const DATE_FORMAT_TABLE_2 = 'YYYY-MM-DD'
export const DATE_RANGE_FORMAT = 'd/m/Y'
export const YEAR_MONTH_FORMAT = 'Y-M-d'
export const CSV_EXTENSION_FORMAT = 'application/vnd.ms-excel'
// export const ROLES = [
//     {label: 'Director', value: 'DIRECTOR', department: 6},
//     {label: 'Head of Academic Admin', value: 'HEAD_OF_ACADEMIC_ADMIN', department: 2},
//     {label: 'Manager Academic Admin', value: 'MANAGER_ACADEMIC_ADMIN', department: 2},
//     {label: 'Academic Administrator', value: 'ACADEMIC_ADMINISTRATOR', department: 2},
//     {label: 'Head of School', value: 'HEAD_OF_SCHOOL', department: 2},
//     {label: 'Lecturer ', value: 'LECTURER', department: 2},
//     {label: 'Head of Counselor', value: 'HEAD_OF_COUNSELLOR', department: 3},
//     {label: 'Counselor', value: 'COUNSELLOR', department: 3},
//     {label: 'Receptionist ', value: 'RECEPTIONIST', department: 3},
//     {label: 'Head of Finance', value: 'HEAD_OF_FINANCE', department: 4},
//     {label: 'Finance Manager', value: 'FINANCE_MANAGER', department: 4},
//     {label: 'Finance Assistant Manager', value: 'FINANCE_ASSISTANT_MANAGER', department: 4},
//     {label: 'Finance Executive', value: 'FINANCE_EXECUTIVE', department: 4},
//     {label: 'IT Manager', value: 'IT_MANAGER', department: 1},
//     {label: 'IT Executive', value: 'IT_EXECUTIVE', department: 1},
//     // {label: 'Student', value: 'STUDENT'},
//     // {label: 'Internship Manager', value: 'INTERNSHIP_MANAGER', department:2},
//     {label: 'Student Support Services Manager', value: 'STUDENT_SUPPORT_SERVICES_MANAGER', department: 5},
//     // {label: 'Parents', value: 'PARENTS'},
//     {label: 'Student Life Manager', value: 'STUDENT_LIFE_MANAGER', department: 5}
//     // {label: 'Marketing Manager', value: 'MARKETING_MANAGER', department:3}
//     // {label: 'Librarian', value: 'LIBRARIAN', department:2}
// ]

export const ROLES = {
    itManager: {label: 'IT Manager', value: 'IT_MANAGER', department: 1},
    headOfSchool: {label: 'Head of School', value: 'HEAD_OF_SCHOOL', department: 2},
    lecturer: {label: 'Lecturer ', value: 'LECTURER', department: 2},
    haa: {label: 'Head of Academic Admin', value: 'HEAD_OF_ACADEMIC_ADMIN', department: 2},
    maa: {label: 'Manager Academic Admin', value: 'MANAGER_ACADEMIC_ADMIN', department: 2},
    academicAdmin: {label: 'Academic Administrator', value: 'ACADEMIC_ADMINISTRATOR', department: 2},
    hoc: {label: 'Head of Counselor', value: 'HEAD_OF_COUNSELLOR', department: 3},
    counselor: {label: 'Counselor', value: 'COUNSELLOR', department: 3},
    hof: {label: 'Head of Finance', value: 'HEAD_OF_FINANCE', department: 4},
    fm: {label: 'Finance Manager', value: 'FINANCE_MANAGER', department: 4},
    fe: {label: 'Finance Executive', value: 'FINANCE_EXECUTIVE', department: 4},
//student : {label: 'Student', value: 'STUDENT'},
//internshipManager : {label: 'Internship Manager', value: 'INTERNSHIP_MANAGER', department:3},
//parents : {label: 'Parents', value: 'PARENTS'},
//marketingManager {label: 'Marketing Manager', value: 'MARKETING_MANAGER', department:4}
    librarian: {label: 'Librarian', value: 'LIBRARIAN', department: 5},
    industry: {label: 'Industry', value: 'INDUSTRY', department: 5},
    studentSupportServices: {label: 'Student Support Services', value: 'STUDENT_SUPPORT_SERVICES', department: 5}
}
if (accessList.allowNonDevUserRoles) {
    ROLES.itExecutive = {label: 'IT Executive', value: 'IT_EXECUTIVE', department: 1}
    ROLES.receptionist = {label: 'Receptionist ', value: 'RECEPTIONIST', department: 3}
    ROLES.financeAssistantManager = {
        label: 'Finance Assistant Manager',
        value: 'FINANCE_ASSISTANT_MANAGER',
        department: 4
    }
    ROLES.studentLifeManager = {label: 'Student Life Manager', value: 'STUDENT_LIFE_MANAGER', department: 5}
    ROLES.studentSupportServiceManager = {
        label: 'Student Support Services Manager',
        value: 'STUDENT_SUPPORT_SERVICES_MANAGER',
        department: 5
    }
    ROLES.director = {label: 'Director', value: 'DIRECTOR', department: 6}

}

export const FOLLOWUP_TYPES = {
    pendingPayment: "PENDING_PAYMENT",
    applicationSubmitted: "APPLICATION_SUBMITTED",
    futureInquiry: "FUTURE_INQUIRY",
    notInterested: "NOT_INTERESTED",
    hoaApproval: "HOA_APPROVAL",
    hosApproval: "HOS_APPROVAL"
}
export const HOS_STATUS = [
    {label: 'All', value: 'ALL'},
    {label: 'Pending', value: 'PENDING'},
    {label: 'Approved', value: 'APPROVED'},
    {label: 'Shared to AA', value: 'SHARED_TO_AA'},
    {label: 'Pending by AA', value: 'PENDING_BY_AA'},
    {label: 'Pending by FM', value: 'PENDING_BY_FM'}
]
export const FM_EXCEMPTION_STATUS = [
    {label: 'All', value: 'ALL'},
    {label: 'Pending', value: 'PENDING'},
    {label: 'Approved', value: 'APPROVED'},
    {label: 'Rejected', value: 'REJECTED'}
]

export const FM_EXCEMPTION_NEW_STATUS = [
    // {label: 'All', value: 'ALL'},
    // {label: 'Pending', value: 'PENDING'},
    // {label: 'Recommended', value: 'RECOMMENDED'},
    // {label: 'Rejected', value: 'REJECTED'}
    {
        value: null,
        label: 'All'
    },
    {
        value: "SEND_TO_FM",
        label: "Send to FM"
    },
    {
        value: "SEND_TO_HOF",
        label: "Send to HOF"
    },
    // {
    //     value: "SEND_TO_HOS",
    //     label: 'Send to HOS'
    // }, {
    //     value: "HOS_RECOMMENDED",
    //     label: "HOS Recommended"
    // }, {
    //     value: "HOS_REJECTED",
    //     label: "HOS Rejected"
    // }, {
    //     value: "AA_RECOMMENDED",
    //     label: "AA Recommended"
    // },
    // {
    //     value: "AA_REJECTED",
    //     label: "AA Rejected"
    // },
    // {
    //     value: "FM_RECOMMENDED",
    //     label: "FM Recommended"
    // },
    {
        value: "FM_REJECTED",
        label: "FM Rejected"
    }, {
        value: "HOF_RECOMMENDED",
        label: "HOF Recommended"
    }, {
        value: "HOF_REJECTED",
        label: "HOF Rejected"
    }
    // {
    //     value: "SEND_TO_AA",
    //     label: "Send to AA"
    // },
]

// export const PAYMENT_INTERVALS = [
//     {label: 'Monthly - 30 days ', value: '1-M-ANY'},
//     {label: '2 Semester - 3 months', value: '3-M-2'},
//     {label: '2 Semester - 4 months', value: '4-M-2'},
//     {label: '3 Semester - 3 months ', value: '3-M-3'},
//     {label: '4 Semester - 4 months', value: '4-M-4'},
//     {label: 'Annual - one time payment ', value: '12-M-ANY'}
// ]

export const FEE_TYPE = [
    {label: 'Registration Fee', value: 'REGISTRATION_FEE'},
    {label: 'Library Fee', value: 'LIBRARY_FEE'},
    {label: 'SU Fee', value: 'SU_FEE'},
    {label: 'Course Fee', value: 'COURSE_FEE'}
]

export const DISCOUNT_TYPE = [
    {label: 'Percentage', value: 'PERCENTAGE'},
    {label: 'Amount(LKR)', value: 'FIXED'},
    {label: 'Amount(USD)', value: 'FIXED'}
]

export const PAYMENT_METHOD = [
    {label: 'Online', value: 'ONLINE'},
    {label: 'Cash', value: 'CASH'},
    {label: 'Bank Deposit', value: 'BANK'}
]

export const ALL_PAYMENT_METHOD = [
    {label: 'Online', value: 'ONLINE'},
    {label: 'Cash', value: 'CASH'},
    {label: 'Bank Deposit', value: 'BANK'},
    {label: 'Deposit', value: 'DEPOSIT'},
    {label: 'Cheque', value: 'CHEQUE'},
    {label: 'Card', value: 'CARD'}
]

export const PAYMENT_TYPE = [
    {label: 'Payment', value: 'PAYMENT'},
    {label: 'Refund', value: 'REFUND'},
    {label: 'Transfer', value: 'TRANSFER'}
]

export const TABLE_STATUS = ["ACTIVE", "INACTIVE"]
export const FEE_SCHEME_STATUS = [
    {value: null, label: 'All'},
    {label: 'Active', value: 'ACTIVE'},
    {label: 'Inactive', value: 'INACTIVE'}
]
export const SUBMITTED_APPLICATION_STATUS = [
    {value: null, label: 'All'},
    {label: 'Offer Letter Shared', value: 'OFFER_LETTER_SHARED'},
    {label: 'Registration Link Shared', value: 'REGISTRATION_LINK_SHARED'},
    {label: 'Application Submitted', value: 'APPLICATION_SUBMITTED'},
    {label: 'Special Approved', value: 'SPECIAL_APPROVED'},
    {label: 'Pending Payment', value: 'PENDING_PAYMENT'},
    {label: 'Pending Enrollment', value: 'PENDING_ENROLLMENT'},
    {label: 'Course Detail Shared', value: 'COURSE_DETAIL_SHARED'}
]


export const SCHEME_ENROLLED_TYPE = [
    {label: 'Student Enrolled', value: 'STUDENT_ENROLLED'},
    {label: 'No Payment Scheme Assigned', value: 'NO_PAYMENT_SCHEME_ASSIGNED'},
    {label: 'Payment Scheme Assigned', value: 'PAYMENT_SCHEME_ASSIGNED'}
]

export const COURSE_TYPES = [
    {label: 'Full Time', value: 'FULL_TIME'},
    // {label: 'Part Time', value: 'PART_TIME'},
    // {label: 'Online', value: 'ONLINE'},
    // {label: 'Physical', value: 'PHYSICAL'}
    {label: 'ONLINE - PART TIME', value: 'ONLINE_PART_TIME'},
    {label: 'PHYSICAL - PART TIME', value: 'PHYSICAL_PART_TIME'}
]

export const GRADING_SCHEME_STATUS = [
    {label: 'Pass', value: 'PASS', key: 0},
    {label: 'Fail', value: 'FAIL', key: 1}
]

export const STUDY_MODES = [
    {label: 'Full Time', value: 'FULL_TIME'},
    {label: 'Part Time', value: 'PART_TIME'},
    {label: 'Online', value: 'ONLINE'},
    {label: 'Physical', value: 'PHYSICAL'}
]

export const OVERALL_MARK_CALCULATION = [
    {label: 'Grading point average (Course Grading)', value: 'GRADING_POINT_AVERAGE'},
    {label: 'Total grade point (Module Grading)', value: 'TOTAL_GRADING_POINT'}
]

export const GPA_TYPE = [
    {label: 'Calculate ', value: 'CALCULATE'},
    {label: 'Not calculate ', value: 'NOT_CALCULATE'}
]

export const MODULE_TYPE = [
    {label: 'Core ', value: 'CORE'},
    {label: 'Elective ', value: 'ELECTIVE'}
]

export const MODULE_CATEGORY = [
    {label: 'Normal ', value: 'NORMAL'},
    {label: 'Project', value: 'PROJECT'},
    {label: 'Multi Semester', value: 'MULTI_SEMESTER'}

]

export const MODULE_CSV_HEADER = [
    {label: "Module Code", key: "moduleCode"},
    {label: "Module Name", key: "moduleName"},
    {label: "Description", key: "description"},
    {label: "Category", key: "moduleCategory"},
    {label: "Type", key: "moduleType"},
    {label: "Credits", key: "noOfCredits"},
    {label: "GPA Type", key: "gpaCalculate"},
    {label: "Assessment Scheme", key: "assessmentSchemeCode"}
]

export const COURSE_CSV_HEADER = [
    {label: `${basicInfo.courseLabel} Code`, key: "code"},
    {label: `${basicInfo.courseLabel} Name`, key: "name"},
    {label: "Description", key: "description"},
    {label: "Qualification", key: "qualification"},
    {label: "Specialization", key: "specialization"},
    // {label: "type", key: "type"},
    {label: basicInfo.schoolLabel, key: "school"},
    {label: "Provide", key: "provide"},
    {label: "Program Code", key: "program"},
    {label: "Level", key: "level"},
    {label: "Center", key: "center"},
    {label: "Credits", key: "credits"}
]

export const MARKINGS_CSV_HEADER = [
    {label: "Batch", key: "batchName"},
    {label: "Module", key: "moduleName"},
    {label: basicInfo.courseLabel, key: "courseName"},
    {label: "Level", key: "levelName"},
    {label: "Semester", key: "semesterName"},
    {label: "Student", key: "studentName"},
    {label: basicInfo.regText, key: "cbNo"},
    {label: "Diagnostic Assessment", key: "diagnosticAssessment"},
    {label: "Formative Assessment", key: "formativeAssessment"},
    {label: "Summary Assessment", key: "summativeAssessment"},
    {label: "Average", key: "average"},
    {label: "Exam Status", key: "examStatus"}
]

export const STUDENTS_MARKINGS_CSV_HEADER = [
    {label: "Student", key: "studentName"},
    {label: basicInfo.regText, key: "cbNo"},
    // {label: "Diagnostic Type", key: "diagnosticType"},
    // {label: "Diagnostic Assessment", key: "diagnosticAssessment"},
    // {label: "Diagnostic Grade", key: "diagnosticGrade"},
    // {label: "Formative Type", key: "formativeType"},
    // {label: "Formative Assessment", key: "formativeAssessment"},
    // {label: "Formative Grade", key: "formativeGrade"},
    // {label: "Summary Type", key: "summativeType"},
    // {label: "Summary Assessment", key: "summativeAssessment"},
    // {label: "Summary Grade", key: "summativeGrade"},
    {label: "Average", key: "average"},
    {label: "Average Grade", key: "averageGrade"},
    {label: "Exam Status", key: "examStatus"}

]

export const FILTER_TYPES = {
    input: 'INPUT',
    dropDown: 'DROP_DOWN',
    datePicker: 'DATE_PICKER',
    rangePicker: 'RANGE_PICKER',
    number: 'NUMBER',
    timeRangePicker: 'TIME_RANGE_PICKER'
}

export const ENROLLMENT_REQUESTS_CSV_HEADER = [
    {label: "Inquiry No", key: "inquiryNo"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Request Date", key: "requestDate"},
    {label: "Status", key: "status"},
    {label: "Counsellor Name", key: "counselorName"},
    {label: "Course Name", key: "courseName"},
    // {label: "Discounts", key: "discounts"},
    {label: "Intake Code", key: "intakeCode"},
    {label: "Deposit Date", key: "depositDate"},
    {label: "Fee Type", key: "feeType"},
    {label: "Amount", key: "amount"}
]

export const CLASS_SETUP_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: "Student No.", key: "studentId"},
    {label: "Student Name", key: "studentName"},
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Class Name", key: "className"},
    {label: "Class Code", key: "classCode"},
    {label: "Course Name", key: "courseName"},
    {label: "Batch Code", key: "batchCode"}
]
export const UNASSIGNED_INQUIRIES_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: "Inq No.", key: "inquiryId"},
    {label: "Inquiry Date", key: "requestedDate"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Remark", key: "remark"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"}
]
export const UPCOMING_CLASSES_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: "Class Date", key: "actualDate"},
    {label: "Class Time", key: "classTime"},
    {label: "Lecturer Name", key: "lectureName"},
    {label: "Venue", key: "venueName"},
    {label: "Module Name", key: "moduleName"},
    {label: "Module Code", key: "moduleCode"},
    {label: "Class Name", key: "className"},
    {label: "Class Slot Name", key: "slotName"}
]
export const EXAM_SCHEDULE_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: "Exam Date", key: "examDate"},
    {label: "Module", key: "moduleName"},
    {label: "Lecturer Name", key: "lecturer"},
    {label: "Time", key: "time"},
    {label: "Total No of Students", key: "noOfStudents"}
]
export const COURSE_TRANSFER_REQUESTS_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: "Student Name", key: "studentName"},
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Current Course", key: "currentCourse"},
    {label: "Requested Course", key: "requestedCourse"},
    {label: "Status", key: "status"},
    {label: "Branch", key: "branchName"},
    {label: "Level", key: "levelName"},
    {label: "Intake", key: "intakeCode"},
    {label: "Payment Plan", key: "paymentPlan"},
    {label: "Student Remark", key: "studentRemark"}
]
export const ASSESSMENT_TIME_TABLE_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: basicInfo.schoolLabel, key: "schoolName"},
    {label: "Course Name", key: "courseName"},
    {label: "Batch", key: "batchCode"}
]
export const EXAM_STUDENT_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Student Name", key: "studentName"},
    {label: "Class Name", key: "className"},
    {label: "Batch", key: "batchCode"},
    {label: "Attempt", key: "attemptName"}
]
export const CUSTOM_DISCOUNT_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: "Inq No.", key: "inquiryNumber"},
    {label: "Requested Date", key: "requestDate"},
    {label: "Student Name", key: "studentName"},
    {label: "Course Name", key: "courseName"},
    {label: "Status", key: "status"},
    {label: "Intake", key: "intakeCode"},
    {label: "Payment Plan", key: "paymentPlanName"},
    {label: "Counsellor", key: "counsellorRemark"},
    {label: "FE Remark", key: "feRemark"},
    {label: "FM Remark", key: "fmRemark"}
]

export const DAILY_TRANSACTION_CSV_HEADER = [
    {label: "Receipt No", key: "receiptId"},
    {label: "Student Name", key: "studentName"},
    // {label: "StudentId", key: "studentId"}, apiit req cbNumber not the studentId
    {label: basicInfo.regText, key: "studentId"},
    {label: "Date", key: "date"},
    {label: "Transaction Type", key: "transactionType"},
    {label: "Currency", key: "currencyType"},
    {label: "Fee Amount", key: "amount"},
    {label: "Late Fee", key: "lateFeePaid"},
    {label: "Late Fee Wave Off", key: "lateFeeWaveOff"},
    {label: "Tax", key: "paidTaxAmount"},
    // {label: "Total Amount", key: "totalAmountPaid"},
    {label: "Paid Amount", key: "totalAmountPaid"},
    // {label: "Course Deduction", key: "courseDeduction"},
    // {label: "Tax Allocation", key: "taxAllocation"},
    {label: "Remark", key: "remark"},
    {label: "Discount", key: "discount"},
    {label: "Discount Amount", key: "discountAmount"},
    {label: "Previous Overpaid Amount", key: "previousOverPaidAmount"},
    {label: "Deducted Exemption Fee", key: "deductedExemptionFee"},
    {label: "Counsellor", key: "counsellorName"},
    {label: basicInfo.courseLabel, key: "courseName"},
    {label: "Batch", key: "batchCode"},
    {label: "Email", key: "studentEmail"},
    {label: "Contact No", key: "studentNumber"},
    {label: "Intake", key: "intakeCode"},
    {label: "Payment Type", key: "paymentType"},
    {label: "Payment Method", key: "paymentMethod"},
    {label: "Deposit Date", key: "depositedDate"},
    {label: "Collected Date", key: "collectedDate"},
    {label: "Bank", key: "bankName"},
    {label: "Cheque No", key: "chequeNo"},
    {label: "Card Receipt No", key: "cardReceiptNo"},
    {label: "Card Type", key: "cardType"},
    {label: "Refund Type", key: "refundType"},
    {label: "Refund Method", key: "refundMethod"},
    // {label: "Transfer Type", key: "transferType"},
    // {label: "Transfer Method", key: "transferMethod"},
    {label: "Transfer In", key: "transferIn"},
    {label: "Transfer Out", key: "transferOut"},
    {label: "Description", key: "description"}
]

export const COLLECT_PAYMENT_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNo"},
    {label: "Student Name", key: "studentName"},
    {label: "Contact", key: "contact"},
    {label: "Email", key: "email"},
    {label: "Last Payment", key: "lastPayment"},
    {label: "Counsellor", key: "counselor"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "Total Amount", key: "totalAmount"},
    {label: "Batch", key: "batch"},
    {label: "Payment Plan", key: "paymentPlan"},
    {label: "Outstanding", key: "outstanding"},
    {label: "Intake", key: "intake"},
    {label: "Payment Due", key: "paymentDue"}
]

export const PENDING_COLLECTION_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Student Name", key: "studentName"},
    {label: "StudentId", key: "studentId"},
    {label: "Contact No", key: "studentMobile"},
    {label: "Email", key: "studentEmail"},
    {label: "Due Date", key: "dueDate"},
    {label: "Amount", key: "amount"},
    {label: "Late Fee", key: "lateFee"},
    {label: basicInfo.courseLabel, key: "courseName"},
    {label: "Batch", key: "batchCode"},
    {label: "Last Payment Date", key: "lastPaymentDate"},
    {label: "Last Payment Amount", key: "lastPaymentAmount"}
]

export const INVOICE_PAYMENT_METHOD = [
    {label: 'Deposit', value: 'DEPOSIT'},
    {label: 'Cheque', value: 'CHEQUE'},
    {label: 'Cash', value: 'CASH'},
    {label: 'Card', value: 'CARD'},
    {label: 'Frimi', value: 'FRIMI'},
    {label: 'MyFees', value: 'MYFEES'},
    {label: 'Online Transfer', value: 'ONLINE_TRANSFER'}
]

export const ALL_DAILY_TRANS_PAYMENT_METHOD = [
    {label: 'Deposit', value: 'DEPOSIT'},
    {label: 'Cheque', value: 'CHEQUE'},
    {label: 'Cash', value: 'CASH'},
    {label: 'Card', value: 'CARD'},
    {label: 'Frimi', value: 'FRIMI'},
    {label: 'MyFees', value: 'MYFEES'},
    {label: 'Online Transfer', value: 'ONLINE_TRANSFER'},
    {label: 'Online(Payment Gateway)', value: 'ONLINE'}
]

export const APPROVE_PAYMENT_VIEW = {
    enrollment: 'ENROLLMENT_REQUEST',
    bankTransfer: 'BANK_TRANSFER',
    collectPayment: 'COLLECT_PAYMENT',
    //this was added to handle the change payment plan btn in smp
    studentProfile: 'STUDENT_PROFILE'
}

export const FILTERS = {
    name: undefined,
    course: undefined,
    dateRange: undefined,
    appointmentDate: undefined,
    lastFollowupDate: undefined,
    hos: undefined,
    status: undefined,
    counsellor: undefined,
    intake: undefined,
    inquiryType: undefined,
    marketingCode: undefined,
    inquiryStatus: undefined,
    counselor: undefined,
    feeNo: undefined,
    feeName: undefined,
    batch: null,
    cb: '',
    collected: null,
    method: null,
    nic: '',
    receipt: '',
    type: null,
    cbNumber: undefined,
    studentName: undefined,
    nicPassport: undefined,
    startDate: undefined,
    endDate: undefined,
    courseId: undefined,
    counselorId: undefined,
    employeeNo: '',
    department: undefined,
    role: undefined,
    school: undefined,
    defaultStatue: {value: 'PENDING', label: 'Pending'},
    subStatus: null,
    classCode: undefined,
    contact: '',
    module: undefined,
    attempt: undefined,
    level: undefined,
    class: undefined,
    inquiryNo: '',
    lecturerId: undefined,
    lecturer: undefined,
    venue: undefined,
    timeRange: undefined,
    semester: undefined,
    studentType: null,
    email: '',
    subject: undefined,
    date: null
}

export const INVOICE_TYPE = {
    inquiry: 'inquiry',
    student: 'student'
}

export const academicTableFooter = [
    {
        class: 'class-week',
        label: 'Class Week',
        iconText: '1'
    },
    {
        class: 'exam-week',
        label: 'Exam Week',
        iconText: 'E'
    },
    {
        class: 'study-leave-week',
        label: 'Study Leave Week',
        iconText: 'S'
    },
    {
        class: 'holiday-week',
        label: 'Holiday Week',
        iconText: 'H'
    },
    {
        class: 'class-range',
        label: 'Class Timeline',
        iconText: ''
    }
]

export const SLOT_INFO_DAYS = [
    {
        name: 'MO',
        value: 'MONDAY',
        no: 1
    }, {
        name: 'TU',
        value: 'TUESDAY',
        no: 2
    }, {
        name: 'WE',
        value: 'WEDNESDAY',
        no: 3
    }, {
        name: 'TH',
        value: 'THURSDAY',
        no: 4
    }, {
        name: 'FR',
        value: 'FRIDAY',
        no: 5
    }, {
        name: 'SA',
        value: 'SATURDAY',
        no: 6
    }, {
        name: 'SU',
        value: 'SUNDAY',
        no: 7
    }
]

export const LECTUURER_ALLOCATION_TABLE_FOOTER = [
    {
        class: 'lower',
        label: 'Lower than Max Hrs/Week',
        iconText: ''
    },
    {
        class: 'high',
        label: 'Max Hrs/Week Exceeded',
        iconText: ''
    },
    {
        class: 'reached',
        label: 'Max Hrs Reached',
        iconText: ''
    },
    {
        class: 'holiday',
        label: 'Holiday Week',
        iconText: 'H'
    }
]

export const LECTURER_TYPES = [
    {value: 'PART_TIME', label: 'Part Time'},
    {value: 'FULL_TIME', label: 'Full Time'},
    {value: 'VISITING_LEC', label: 'Visiting'}
]

export const TIME_SLOT_TYPES = {
    student: 'STUDENT',
    lecturer: 'LECTURER',
    venue: 'VENUE'
}

export const TIME_PICKER_FORMAT = 'hh:mm:ss'
export const TIME_PICKER_FORMAT2 = 'hh:mm'
export const TIME_PICKER_FORMAT_24 = 'HH:mm'
export const TIME_PICKER_FORMAT_24_SEC = 'HH:mm:00'
export const SLOT_VALIDATION_TIME_FORMAT = 'hh:mm:ss'
export const SLOT_CREATION_TIME_FORMAT = 'HH:mm:00'
export const ATTENDANCE_STATUS = ['PRESENT', 'ABSENT', 'LATE', 'PENDING']

export const viewStudentTypes = {
    schedule: 'SCHEDULE'
}

export const LIST_SECTION = {
    modules: null,
    classes: null,
    course: null,
    assessment: null,
    moduleName: null
}

export const LEAVE_REQUEST_STATUS = [
    {label: 'All', value: 'ALL'},
    {label: 'Pending', value: 'PENDING'},
    {label: 'Approved', value: 'APPROVED'},
    {label: 'Partially Approved', value: 'PARTIALLY_APPROVED'},
    {label: 'Rejected', value: 'REJECTED'}
]

export const ASSESSMENT_TABLE_STATUS = {
    pending: 'PENDING',
    submitted: 'SUBMITTED',
    moderated: 'MODERATED',
    actual: 'ACTUAL'
}

export const GRADES = {
    a: 'A',
    b: 'B',
    f: 'F'
}

export const EXAM_STATUS = {
    pass: 'PASS',
    fail: 'FAIL',
    absent: 'ABSENT'
}

export const EXAM_STATUS_DROPDOWN = [
    {label: 'Pass', value: 'PASS'},
    {label: 'Fail', value: 'FAIL'},
    {label: 'Absent', value: 'ABSENT'}
]

export const STUDENT_MARK_TYPES = {
    saveAsDraft: 'SAVE_AS_DRAFT',
    submitToHaa: 'SUBMIT_TO_HAA',
    moderatedPublished: 'MODERATED_PUBLISHED',
    actualPublished: 'ACTUAL_PUBLISHED',
    moderatedUnpublished: 'MODERATED_UNPUBLISHED',
    actualUnpublished: 'ACTUAL_UNPUBLISHED'
}

export const ASSESSMENT_MARKING_SHEET_HAA_CSV_HEADER = [
    {label: `${basicInfo.regText} / Uni ID`, key: "docketCbNo"},
    {label: "Batch", key: "batch"},
    {label: "First Marks", key: "marks"},
    {label: "Absent", key: "absent"},
    {label: "Moderated Marks", key: "moderatedMarks"},
    {label: "Actual Marks", key: "actualMarks"},
    {label: "Grade", key: "grade"},
    {label: "Exam Status", key: "examStatus"},
    {label: "Publish / Unpublish", key: "publishUnpublish"},
    {label: "Actual Remark", key: "actualRemark"},
    {label: "Actual Remark Date", key: "actualRemarkDate"},
    {label: "Actual Remark User", key: "actualRemarkUser"},
    {label: "Lecturer Remark", key: "lecturerRemark"},
    {label: "Lecturer Remark Date", key: "lecturerRemarkDate"},
    {label: "Lecturer Remark User", key: "lecturerRemarkUser"},
    {label: "Moderator Remark", key: "moderatorRemark"},
    {label: "Moderator Remark Date", key: "moderatorRemarkDate"},
    {label: "Moderator Remark User", key: "moderatorRemarkUser"}
]

export const ASSESSMENT_MARKING_SHEET_HOS_CSV_HEADER = [
    {label: `${basicInfo.regText} / Uni ID`, key: "docketCbNo"},
    {label: "Batch", key: "batch"},
    {label: "Marks", key: "marks"},
    {label: "Absent", key: "absent"},
    {label: "Grade", key: "grade"},
    {label: "Exam Status", key: "examStatus"},
    {label: "Lecturer Remark", key: "lecturerRemark"},
    {label: "Lecturer Remark Date", key: "lecturerRemarkDate"},
    {label: "Lecturer Remark User", key: "lecturerRemarkUser"}
]

export const MARKING_VIEW_TYPES = {
    lecturerEnter: {marks: true, absent: true, remark: true, btnImport: true, btnSaveAsDraft: true, btnSubmitHaa: true},
    lecturerView: {marks: false, absent: false, remark: false, lblPassingPercentage: true, tblAllMarks: true},
    haaEnter: {
        marks: true,
        absent: true,
        remark: true,
        btnImport: true,
        btnSaveAsDraft: true,
        returnDate: true,
        copyButton: true,
        btnPublishHaa: true,
        btnUnpublishHaa: true
    }
}

export const HAA_ASSESSMENT_STATUS = [
    {label: 'All', value: null},
    {label: 'Pending', value: 'PENDING'},
    {label: 'Submitted', value: 'SUBMITTED'},
    {label: 'Moderated', value: 'MODERATED'},
    {label: 'Moderated Unpublished', value: 'MODERATED_UNPUBLISHED'},
    {label: 'Moderated Published', value: 'MODERATED_PUBLISHED'},
    {label: 'Actual', value: 'ACTUAL'},
    {label: 'Actual Unpublished', value: 'ACTUAL_UNPUBLISHED'},
    {label: 'Actual Published', value: 'ACTUAL_PUBLISHED'},
    {label: 'Absent', value: 'ABSENT'}
]

export const ASSESSMENT_REMARK_TYPES = [
    {value: 'FIRST', label: 'First'},
    {value: 'MODERATED', label: 'Moderated'},
    {value: 'ACTUAL', label: 'Actual'}
]

export const PUBLISH_UNPUBLISH = {
    published: 'PUBLISHED',
    unPublished: 'UNPUBLISHED'
}

export const ASSESSMENT_MARKING_CSV_TEMPLATE_HEADER = [
    {label: `${basicInfo.regText} / DocketNumber`, key: "cbDocketNumber"},
    {label: "marks", key: "marks"},
    {label: "lecturerRemark", key: "lecturerRemark"}
]

export const ASSESSMENT_MARKING_HAA_CSV_TEMPLATE_HEADER = [
    {label: `${basicInfo.regText} / DocketNumber`, key: "cbDocketNumber"},
    {label: "submittedMark", key: "submittedMark"},
    {label: "moderatedMark", key: "moderatedMark"},
    {label: "actualMark", key: "actualMark"},
    {label: "remarkTypeValue", key: "remarkTypeValue"}
    // {label: "remarkType", key: "remarkType"}
]

export const ASSESSMENT_TYPES = [
    {label: 'Group', value: 'GROUP'},
    {label: 'Exam', value: 'EXAM'},
    {label: 'Individual', value: 'INDIVIDUAL'},
    {label: 'Group', value: 'GROUP'}
]

export const STUD_ADDRESS = [
    {label: 'Residential', value: 'RESIDENTIAL'},
    {label: 'Permanent', value: 'PERMANENT'}
]

export const STUDENT_COURSES_STATUS = {
    pending: 'PENDING',
    enrolled: 'ENROLLED',
    completed: 'COMPLETED',
    rejected: 'REJECTED',
    ongoing: 'ONGOING'
}

export const STUDENT_MODULE_CSV_HEADER = [
    {label: "Module", key: "moduleName"},
    {label: "Module Type", key: "moduleType"},
    {label: "No Of Credits", key: "noOfCredits"},
    {label: "Average Marks", key: "avgMarks"},
    {label: "Exam Status", key: "examStatus"},
    {label: "Average Attendance", key: "avgAttendance"},
    {label: "Module Status", key: "moduleStatus"}
]

export const STUDENT_RESULTS_CSV_HEADER = [
    {label: "Module", key: "moduleName"},
    {label: "Module Type", key: "moduleType"},
    {label: "Semester", key: "semester"},
    {label: "Attempt", key: "attempt"},
    {label: "Marks", key: "marks"},
    {label: "Grade", key: "grade"},
    {label: "Status", key: "status"}
]

export const STUDENT_ATTENDANCE_CSV_HEADER = [
    {label: "Type", key: "type"},
    {label: "Date", key: "date"},
    {label: "Time Duration", key: "timeDuration"},
    {label: "Venue", key: "venue"},
    {label: "Status", key: "status"}
]

export const STUDENT_ASSESSMENT_RESULT_CSV_HEADER = [
    {label: "Name", key: "name"},
    {label: "Attempt", key: "attempt"},
    {label: "Type", key: "type"},
    {label: "Weight", key: "weight"},
    {label: "First Marks", key: "firstMark"},
    {label: "Moderated Marks", key: "moderatedMark"},
    {label: "Actual Marks", key: "actualMark"}
]

export const STUDENT_QUALIFICATION_STATUS = {
    pending: 'PENDING',
    approved: 'APPROVED',
    rejected: 'REJECTED'
}

export const STUDENT_PROFILE_VIEW_TYPES = {
    changePaymentPlan: 'CHANGE_PAYMENT_PLAN',
    stepperView: 'STEPPER_VIEW'
}

export const STUDENT_FOLLOWUP_STATUS = {
    futureIntake: 'FUTURE_INTAKE',
    followUp: 'FOLLOW_UP'
}

// student master profile edit access roles
export const SMP_EDIT_ACCESS_ROLES = [
    "HEAD_OF_ACADEMIC_ADMIN", "MANAGER_ACADEMIC_ADMIN", "HEAD_OF_FINANCE",
    "FINANCE_MANAGER", "FINANCE_EXECUTIVE", "IT_MANAGER", "HEAD_OF_COUNSELLOR", "COUNSELLOR"
]

export const SMP_FINANCE_EDIT_ACCESS_ROLES = ["HEAD_OF_FINANCE", "FINANCE_MANAGER", "FINANCE_EXECUTIVE"]

export const PROGRESSION_REQUEST_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Name", key: "name"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "Batch", key: "batch"},
    {label: "Applied Level", key: "appliedLevel"},
    {label: "Core Modules", key: "coreModules"},
    {label: "Elective Modules", key: "electiveModules"},
    // {label: "Study Mode", key: "studyMode"},
    {label: "Remark", key: "remark"}
]

export const PROGRESSION_APPLY_STATUS = {
    approved: 'APPROVED',
    applicable: 'APPLICABLE',
    pending: 'PENDING',
    rejected: 'REJECTED'
}

export const PROGRESSION_ELIGIBLE_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Name", key: "name"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "Batch", key: "batch"},
    {label: "Approved Level", key: "approvedLevel"},
    {label: "Status", key: "status"},
    {label: "Core Modules", key: "coreModules"},
    {label: "Elective Modules", key: "electiveModules"},
    // {label: "Study Mode", key: "studyMode"},
    {label: "Remark", key: "remark"},
    {label: "Mobile", key: "mobile"},
    {label: "Email", key: "email"}
]

export const ELIGIBLE_STUDENT_STATUS = {
    approved: 'APPROVED',
    pending: 'PENDING',
    rejected: 'REJECTED',
    requested: 'REQUESTED',
    recommended: 'RECOMMENDED',
    progressed: 'PROGRESSED',
    graduated: 'GRADUATED'
}

export const ELIGIBLE_STUDENT_FILTER_STATUS = [
    {label: 'All', value: null},
    {label: 'Pending', value: 'PENDING'},
    {label: 'Not Eligible', value: 'NOT_ELIGIBLE'},
    {label: 'Break', value: 'BREAK'},
    {label: 'Rejected', value: 'REJECTED'},
    {label: 'Approved', value: 'APPROVED'}
]

// export const PROGRESSION_APPROVAL_FILTER_STATUS = [
//     {label: 'All', value: null},
//     {label: 'Pending', value: 'PENDING'},
//     {label: 'Progressed', value: 'PROGRESSED'},
//     {label: 'Recommended', value: 'RECOMMENDED'}
// ]

export const PROGRESSION_APPROVAL_FILTER_STATUS = [
    {label: 'All', value: null},
    {label: 'Pending', value: 'PENDING'},
    //{label: 'Progressed', value: 'PROGRESSED'},
    //{label: 'Recommended', value: 'RECOMMENDED'},
    // {label: 'Applicable', value: 'APPLICABLE'},
    {label: 'Rejected', value: 'REJECTED'},
    {label: 'Graduated', value: 'GRADUATED'}

    // {label: 'Approved', value: 'APPROVED '}
]

export const PROGRESSION_APPROVAL_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Name", key: "name"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "Batch", key: "batch"},
    {label: "Current Level", key: "currentLevel"},
    {label: "Status", key: "status"},
    {label: "Core Modules", key: "coreModules"},
    {label: "Elective Modules", key: "electiveModules"}
    // {label: "Study Mode", key: "studyMode"}
]

export const HAA_SPECIAL_APPROVALS_STATUS = [
    {label: 'All', value: null},
    {label: 'Pending', value: 'PENDING'},
    {label: 'Rejected', value: 'REJECTED'},
    {label: 'Recommended', value: 'RECOMMENDED'}
]
export const STUDENT_DROP_STATUS = [
    {label: 'Shared to SSM', value: 'SHARED_TO_SSM', type: 'DROP_EXIT'},
    {label: 'Shared to FM', value: 'SHARED_TO_FM', type: 'DROP_EXIT'},
    {label: 'Rejected by SSM', value: 'REJECTED_BY_SSM', type: 'DROP_EXIT'},
    {label: 'Rejected by FM', value: 'REJECTED_BY_FM', type: 'DROP_EXIT'},
    {label: 'Shared to HAA by FM', value: 'SHARED_TO_HAA_BY_FM', type: 'DROP_EXIT'},
    {label: 'Rejected', value: 'REJECTED', type: 'DROP_EXIT'},
    {label: 'Dropped', value: 'DROPPED', type: 'DROP_EXIT'},
    {label: 'Shared to HAA by ST', value: 'SHARED_TO_HAA_BY_ST', type: 'EXIT'},
    {label: 'Rejected by HAA', value: 'REJECTED_BY_HAA', type: 'EXIT'},
    {label: 'Canceled by ST', value: 'CANCELED_BY_STUDENT', type: 'EXIT'},
    {label: 'Shared to Librarian', value: 'SHARED_TO_LIBRARIAN', type: 'DROP_EXIT'}
]

export const STUDENT_DROP = ['SHARED_TO_SSM', 'SHARED_TO_FM', 'REJECTED_BY_SSM', 'REJECTED_BY_FM', 'SHARED_TO_HAA_BY_FM', 'REJECTED', 'DROPPED', 'SHARED_TO_HAA_BY_ST', 'REJECTED_BY_HAA', 'CANCELED_BY_STUDENT', 'SHARED_TO_LIBRARIAN']

export const STUDENT_DROP_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Student Name", key: "studentName"},
    {label: basicInfo.courseLabel, key: "courseName"},
    {label: "Batch", key: "batchCode"},
    {label: "Branch", key: "branchName"},
    {label: "Level", key: "levelName"},
    {label: "Status", key: "status"},
    {label: "Intake", key: "intakeCode"},
    {label: "Payment Plan", key: "paymentPlanName"}
]

export const MANAGE_PROJECTS_CSV_HEADER = [
    {label: "studentName", key: "studentName"},
    {label: basicInfo.regText, key: "studentId"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "courseCode", key: "courseCode"},
    {label: "moduleName", key: "moduleName"},
    {label: "moduleCode", key: "moduleCode"},
    {label: "batchCode", key: "batchCode"},
    {label: "status", key: "status"},
    {label: "projectId", key: "projectId"},
    {label: "projectTitle", key: "projectTitle"},
    {label: "supervisorId", key: "supervisorId"},
    {label: "accessorId", key: "accessorId"}
]

export const MANAGE_PROJECTS_STATUS = [
    {label: 'Assigned', value: 'ASSIGNED'},
    {label: 'Unassigned', value: 'UNASSIGNED'}
]

export const MANAGE_PROJECTS_STATUS_TYPES = {
    assigned: 'ASSIGNED',
    unAssigned: 'UNASSIGNED',
    approved: 'APPROVED',
    pending: 'PENDING',
    rejected: 'REJECTED'
}
export const STUDENT_EXIT_STATUS = ['PENDING', 'APPROVED', 'REJECTED']

export const MANAGE_PROJECTS_VIEW_CSV_HEADER = [
    {label: "studentName", key: "studentName"},
    {label: basicInfo.regText, key: "cbNo"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "moduleName", key: "moduleName"},
    {label: "batchCode", key: "batchCode"},
    {label: "projectTitle", key: "projectTitle"},
    {label: "supervisorName", key: "supervisorName"},
    {label: "accessorName", key: "accessorName"},
    {label: "index", key: "index"},
    {label: "date", key: "date"},
    {label: "reviewedBy", key: "reviewedBy"},
    {label: "status", key: "status"}
]

export const MANAGE_PROJECT_STUDENT_VIEW_CSV_HEADER = [
    {label: "topic", key: "topic"},
    {label: "supervisorName", key: "supervisorName"},
    {label: "module", key: "module"},
    {label: "index", key: "index"},
    {label: "date", key: "date"},
    {label: "reviewedBy", key: "reviewedBy"},
    {label: "status", key: "status"}
]

export const MANAGE_PROJECT_TEMPLATE_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNo"},
    {label: "projectId", key: "projectId"},
    {label: "projectTitle", key: "projectTitle"},
    {label: "supervisorId", key: "supervisorId"},
    {label: "accessorId", key: "accessorId"}
]

export const MANAGE_PROJECTS_LEC_CSV_HEADER = [
    {label: "studentName", key: "studentName"},
    {label: basicInfo.regText, key: "studentId"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "courseCode", key: "courseCode"},
    {label: "moduleName", key: "moduleName"},
    {label: "moduleCode", key: "moduleCode"},
    {label: "batchCode", key: "batchCode"},
    {label: "projectId", key: "projectId"},
    {label: "projectTitle", key: "projectTitle"},
    {label: "supervisorId", key: "supervisorId"},
    {label: "accessorId", key: "accessorId"}
]

export const MY_INQUIRY_STATUS = [
    {label: 'Followup', value: 'FOLLOWUP'},
    {label: 'Future Intake', value: 'FUTURE_INTAKE'},
    {label: 'Not Interested', value: 'NOT_INTERESTED'}
]

export const EXPORT_LECTURER_CSV_HEADER = [
    {label: "lecturerId", key: "value"},
    {label: "lecturerName", key: "label"}
]

export const BATCHES_EXPORT_TEMPLATE_CSV_HEADER = [
    {label: "Intake Code", key: "intakeCode"},
    {label: "Batch Code", key: "batchCode"},
    {label: "Batch Name", key: "displayName"},
    {label: "Start Date", key: "startDate"},
    {label: "End Date", key: "endDate"}
    // {label: "Study Mode", key: "studyMode"}
]

export const ATTENDANCE_EXPORT_TEMPLATE_CVS_HEADER = [
    {label: "Slot Name", key: "slotName"},
    {label: "Lecturer", key: "lecturer"},
    {label: "Venue", key: "venue"},
    {label: "Day", key: "day"},
    {label: "Time Duration", key: "timeDuration"}
]

export const HOS_APPROVALS_SUB_STATUS = [
    {
        value: null,
        label: 'All'
    },
    {
        value: "SEND_TO_HOS",
        label: 'Send to HOS'
    }, {
        value: "HOS_APPROVED",
        label: "HOS Approved"
    }, {
        value: "HOS_REJECTED",
        label: "HOS Rejected"
    }, {
        value: "AA_APPROVED",
        label: "AA Approved"
    }, {
        value: "AA_REJECTED",
        label: "AA Rejected"
    }, {
        value: "FM_APPROVED",
        label: "FM Approved"
    }, {
        value: "FM_REJECTED",
        label: "FM Rejected"
    }, {
        value: "HOF_APPROVED",
        label: "HOF Approved"
    }, {
        value: "HOF_REJECTED",
        label: "HOF Rejected"
    }, {
        value: "SEND_TO_AA",
        label: "Send to AA"
    }, {
        value: "SEND_TO_HOF",
        label: "Send to HOF"
    }, {
        value: "SEND_TO_FM",
        label: "Send to FM"
    }
]

export const SMP_MODULE_STATUS = [
    {
        label: 'Active',
        value: 'ACTIVE'
    }, {
        label: 'Exempted',
        value: 'EXEMPTED'
    }, {
        label: 'Drop',
        value: 'DROP'
    }
]

export const STUDENT_OTHER_INFO_CSV_HEADER = [
    {label: "Name", key: "name"},
    {label: "Type Name", key: "typeName"},
    {label: "Type", key: "type"},
    {label: "Attachment", key: "attachment"}
]

export const COUNSELLOR_SPECIAL_APPROVALS_SUB_STATUS = [
    {
        label: '', value: ''
    }
]

export const HOLIDAY_TYPES = [
    {label: "Public Holiday", value: "PUBLIC"},
    {label: "Study Leave Holiday", value: "STUDY_LEAVE"},
    {label: "Mid-Year Vacation", value: "MID_YEAR"},
    {label: "Year End Vacation", value: "YEAR_END"}
]
export const ACCOUNT_TYPES = [
    {label: "LKR", value: "LKR"},
    {label: "USD", value: "USD"}
]

export const HOLIDAY_CSV_HEADER = [
    {label: "Holiday Name", key: "holidayName"},
    {label: "Holiday Type", key: "holidayType"},
    {label: "Year", key: "year"},
    {label: "From", key: "from"},
    {label: "To", key: "to"}
]

export const COURSE_TRANSFER_REQUEST_STATUS = [
    'PENDING_MAA',
    'MAA_APPROVED',
    'MAA_REJECTED',
    'PENDING_FM',
    'FM_APPROVED',
    'FM_REJECTED',
    'PENDING_HAA',
    'HAA_APPROVED',
    'HAA_REJECTED'
]

export const COURSE_TRANSFER_REQUEST_STATUS_WITH_LABELS = [
    {label: 'Pending MAA', value: 'PENDING_MAA'},
    {label: 'MAA Approved', value: 'MAA_APPROVED'},
    {label: 'MAA Rejected', value: 'MAA_REJECTED'},
    {label: 'Pending FM', value: 'PENDING_FM'},
    {label: 'FM Approved', value: 'FM_APPROVED'},
    {label: 'FM Rejected', value: 'FM_REJECTED'},
    {label: 'Pending HAA', value: 'PENDING_HAA'},
    {label: 'HAA Approved', value: 'HAA_APPROVED'},
    {label: 'HAA Rejected', value: 'HAA_REJECTED'}
]

export const AMOUNT_TYPE = {
    percentage: "PERCENTAGE",
    fixed: "FIXED"
}

export const MANAGE_PROJECTS_CSV_TEMPLATE_HEADER = [
    {label: basicInfo.regText, key: "studentId"},
    {label: "projectId", key: "projectId"},
    {label: "projectTitle", key: "projectTitle"},
    {label: "supervisorId", key: "supervisorId"},
    {label: "accessorId", key: "accessorId"}
]

export const CLASS_STATUS = [
    {label: 'Done', value: 'DONE'},
    {label: 'Canceled', value: 'CANCELED'},
    {label: 'On Going', value: 'ON_GOING'},
    {label: 'To Be Continued', value: 'TO_BE_CONTINUED'}
]

export const HOS_APPROVALS_STATUS = [
    {
        value: null,
        label: 'All'
    }, {
        value: "SEND_TO_HOS",
        label: 'Send to HOS'
    }, {
        value: "HOS_RECOMMENDED",
        label: "HOS Recommended"
    }, {
        value: "HOS_REJECTED",
        label: "HOS Rejected"
    }, {
        value: "AA_RECOMMENDED",
        label: "AA Recommended"
    }, {
        value: "AA_REJECTED",
        label: "AA Rejected"
    },
    // {
    //     value: "FM_RECOMMENDED",
    //     label: "FM Recommended"
    // },
    {
        value: "FM_REJECTED",
        label: "FM Rejected"
    }, {
        value: "HOF_RECOMMENDED",
        label: "HOF Recommended"
    }, {
        value: "HOF_REJECTED",
        label: "HOF Rejected"
    }, {
        value: "SEND_TO_AA",
        label: "Send to AA"
    }, {
        value: "SEND_TO_HOF",
        label: "Send to HOF"
    }, {
        value: "SEND_TO_FM",
        label: "Send to FM"
    }
]

export const WORD_COUNT = 250
export const LOGIN_TYPES = {microsoft: 'MICROSOFT', default: 'DEFAULT'}
export const LOGIN_STEPS = {
    login: 'LOGIN',
    forgotPassword: 'FORGOT',
    codeVerify: 'VERIFY',
    resetPassword: 'RESET'
}
export const OTP_LENGTH = 5
export const OTP_TIME = 60

export const STUDENT_ONBOARD_ACCESS_LIST = ['APPLICATION_SUBMITTED', 'OFFER_LETTER_SHARED', 'PENDING_HOS_APPROVAL', 'HOS_APPROVED', 'PENDING_PAYMENT', 'PENDING_ENROLLMENT']

export const WEEK_TYPES = {
    class: 'CLASS',
    holiday: 'HOLIDAY',
    study: 'STUDY',
    examWeek: 'EXAM',
    extraClass: 'EXTRA'
}

export const PROGRESSION_TYPES = ['PROGRESSION_APPROVAL', 'ELIGIBLE_STUDENT', 'PROGRESSION_REQUEST', 'GRADUATED_STUDENTS']

export const LEVEL_EXPAND_TYPE = {
    collectPaymentPlan: 'COLLECT_PAYMENT_PLAN',
    feeSchemePaymentPlan: 'FEE_SCHEME_PAYMENT_PLAN',
    feeSchemeDiscount: 'FEE_SCHEME_DISCOUNT'
}

export const KOHA_STATUS = {
    active: 'ACTIVE',
    deActive: 'DEACTIVE'
}

export const STUDENT_ENROLL_CSV_HEADER = [
    {label: basicInfo.regText, key: "indexNumber"},
    {label: "Student Name", key: "studentName"},
    {label: "Contact", key: "contactNumber"},
    {label: basicInfo.courseLabel, key: "course"},
    {label: "Batch", key: "batch"},
    {label: "Intake", key: "intakeName"}
]

export const STUDENT_PROGRESSION_FAIL_MESSAGE = 'There is a payment due. Please settle the payment and try again.'

export const ID_CARD_DATA = 'idCardData'

export const ALL_COUNSELOR_EXPORT = [
    {label: "", key: "value"},
    {label: "", key: "label"}
]

export const COUNTRIES = [
    {name: 'Afghanistan', code: 'AF'},
    {name: 'Åland Islands', code: 'AX'},
    {name: 'Albania', code: 'AL'},
    {name: 'Algeria', code: 'DZ'},
    {name: 'American Samoa', code: 'AS'},
    {name: 'AndorrA', code: 'AD'},
    {name: 'Angola', code: 'AO'},
    {name: 'Anguilla', code: 'AI'},
    {name: 'Antarctica', code: 'AQ'},
    {name: 'Antigua and Barbuda', code: 'AG'},
    {name: 'Argentina', code: 'AR'},
    {name: 'Armenia', code: 'AM'},
    {name: 'Aruba', code: 'AW'},
    {name: 'Australia', code: 'AU'},
    {name: 'Austria', code: 'AT'},
    {name: 'Azerbaijan', code: 'AZ'},
    {name: 'Bahamas', code: 'BS'},
    {name: 'Bahrain', code: 'BH'},
    {name: 'Bangladesh', code: 'BD'},
    {name: 'Barbados', code: 'BB'},
    {name: 'Belarus', code: 'BY'},
    {name: 'Belgium', code: 'BE'},
    {name: 'Belize', code: 'BZ'},
    {name: 'Benin', code: 'BJ'},
    {name: 'Bermuda', code: 'BM'},
    {name: 'Bhutan', code: 'BT'},
    {name: 'Bolivia', code: 'BO'},
    {name: 'Bosnia and Herzegovina', code: 'BA'},
    {name: 'Botswana', code: 'BW'},
    {name: 'Bouvet Island', code: 'BV'},
    {name: 'Brazil', code: 'BR'},
    {name: 'British Indian Ocean Territory', code: 'IO'},
    {name: 'Brunei Darussalam', code: 'BN'},
    {name: 'Bulgaria', code: 'BG'},
    {name: 'Burkina Faso', code: 'BF'},
    {name: 'Burundi', code: 'BI'},
    {name: 'Cambodia', code: 'KH'},
    {name: 'Cameroon', code: 'CM'},
    {name: 'Canada', code: 'CA'},
    {name: 'Cape Verde', code: 'CV'},
    {name: 'Cayman Islands', code: 'KY'},
    {name: 'Central African Republic', code: 'CF'},
    {name: 'Chad', code: 'TD'},
    {name: 'Chile', code: 'CL'},
    {name: 'China', code: 'CN'},
    {name: 'Christmas Island', code: 'CX'},
    {name: 'Cocos (Keeling) Islands', code: 'CC'},
    {name: 'Colombia', code: 'CO'},
    {name: 'Comoros', code: 'KM'},
    {name: 'Congo', code: 'CG'},
    {name: 'Congo, The Democratic Republic of the', code: 'CD'},
    {name: 'Cook Islands', code: 'CK'},
    {name: 'Costa Rica', code: 'CR'},
    {name: 'Cote D\'Ivoire', code: 'CI'},
    {name: 'Croatia', code: 'HR'},
    {name: 'Cuba', code: 'CU'},
    {name: 'Cyprus', code: 'CY'},
    {name: 'Czech Republic', code: 'CZ'},
    {name: 'Denmark', code: 'DK'},
    {name: 'Djibouti', code: 'DJ'},
    {name: 'Dominica', code: 'DM'},
    {name: 'Dominican Republic', code: 'DO'},
    {name: 'Ecuador', code: 'EC'},
    {name: 'Egypt', code: 'EG'},
    {name: 'El Salvador', code: 'SV'},
    {name: 'Equatorial Guinea', code: 'GQ'},
    {name: 'Eritrea', code: 'ER'},
    {name: 'Estonia', code: 'EE'},
    {name: 'Ethiopia', code: 'ET'},
    {name: 'Falkland Islands (Malvinas)', code: 'FK'},
    {name: 'Faroe Islands', code: 'FO'},
    {name: 'Fiji', code: 'FJ'},
    {name: 'Finland', code: 'FI'},
    {name: 'France', code: 'FR'},
    {name: 'French Guiana', code: 'GF'},
    {name: 'French Polynesia', code: 'PF'},
    {name: 'French Southern Territories', code: 'TF'},
    {name: 'Gabon', code: 'GA'},
    {name: 'Gambia', code: 'GM'},
    {name: 'Georgia', code: 'GE'},
    {name: 'Germany', code: 'DE'},
    {name: 'Ghana', code: 'GH'},
    {name: 'Gibraltar', code: 'GI'},
    {name: 'Greece', code: 'GR'},
    {name: 'Greenland', code: 'GL'},
    {name: 'Grenada', code: 'GD'},
    {name: 'Guadeloupe', code: 'GP'},
    {name: 'Guam', code: 'GU'},
    {name: 'Guatemala', code: 'GT'},
    {name: 'Guernsey', code: 'GG'},
    {name: 'Guinea', code: 'GN'},
    {name: 'Guinea-Bissau', code: 'GW'},
    {name: 'Guyana', code: 'GY'},
    {name: 'Haiti', code: 'HT'},
    {name: 'Heard Island and Mcdonald Islands', code: 'HM'},
    {name: 'Holy See (Vatican City State)', code: 'VA'},
    {name: 'Honduras', code: 'HN'},
    {name: 'Hong Kong', code: 'HK'},
    {name: 'Hungary', code: 'HU'},
    {name: 'Iceland', code: 'IS'},
    {name: 'India', code: 'IN'},
    {name: 'Indonesia', code: 'ID'},
    {name: 'Iran, Islamic Republic Of', code: 'IR'},
    {name: 'Iraq', code: 'IQ'},
    {name: 'Ireland', code: 'IE'},
    {name: 'Isle of Man', code: 'IM'},
    {name: 'Israel', code: 'IL'},
    {name: 'Italy', code: 'IT'},
    {name: 'Jamaica', code: 'JM'},
    {name: 'Japan', code: 'JP'},
    {name: 'Jersey', code: 'JE'},
    {name: 'Jordan', code: 'JO'},
    {name: 'Kazakhstan', code: 'KZ'},
    {name: 'Kenya', code: 'KE'},
    {name: 'Kiribati', code: 'KI'},
    {name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
    {name: 'Korea, Republic of', code: 'KR'},
    {name: 'Kuwait', code: 'KW'},
    {name: 'Kyrgyzstan', code: 'KG'},
    {name: 'Lao People\'S Democratic Republic', code: 'LA'},
    {name: 'Latvia', code: 'LV'},
    {name: 'Lebanon', code: 'LB'},
    {name: 'Lesotho', code: 'LS'},
    {name: 'Liberia', code: 'LR'},
    {name: 'Libyan Arab Jamahiriya', code: 'LY'},
    {name: 'Liechtenstein', code: 'LI'},
    {name: 'Lithuania', code: 'LT'},
    {name: 'Luxembourg', code: 'LU'},
    {name: 'Macao', code: 'MO'},
    {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
    {name: 'Madagascar', code: 'MG'},
    {name: 'Malawi', code: 'MW'},
    {name: 'Malaysia', code: 'MY'},
    {name: 'Maldives', code: 'MV'},
    {name: 'Mali', code: 'ML'},
    {name: 'Malta', code: 'MT'},
    {name: 'Marshall Islands', code: 'MH'},
    {name: 'Martinique', code: 'MQ'},
    {name: 'Mauritania', code: 'MR'},
    {name: 'Mauritius', code: 'MU'},
    {name: 'Mayotte', code: 'YT'},
    {name: 'Mexico', code: 'MX'},
    {name: 'Micronesia, Federated States of', code: 'FM'},
    {name: 'Moldova, Republic of', code: 'MD'},
    {name: 'Monaco', code: 'MC'},
    {name: 'Mongolia', code: 'MN'},
    {name: 'Montserrat', code: 'MS'},
    {name: 'Morocco', code: 'MA'},
    {name: 'Mozambique', code: 'MZ'},
    {name: 'Myanmar', code: 'MM'},
    {name: 'Namibia', code: 'NA'},
    {name: 'Nauru', code: 'NR'},
    {name: 'Nepal', code: 'NP'},
    {name: 'Netherlands', code: 'NL'},
    {name: 'Netherlands Antilles', code: 'AN'},
    {name: 'New Caledonia', code: 'NC'},
    {name: 'New Zealand', code: 'NZ'},
    {name: 'Nicaragua', code: 'NI'},
    {name: 'Niger', code: 'NE'},
    {name: 'Nigeria', code: 'NG'},
    {name: 'Niue', code: 'NU'},
    {name: 'Norfolk Island', code: 'NF'},
    {name: 'Northern Mariana Islands', code: 'MP'},
    {name: 'Norway', code: 'NO'},
    {name: 'Oman', code: 'OM'},
    {name: 'Pakistan', code: 'PK'},
    {name: 'Palau', code: 'PW'},
    {name: 'Palestinian Territory, Occupied', code: 'PS'},
    {name: 'Panama', code: 'PA'},
    {name: 'Papua New Guinea', code: 'PG'},
    {name: 'Paraguay', code: 'PY'},
    {name: 'Peru', code: 'PE'},
    {name: 'Philippines', code: 'PH'},
    {name: 'Pitcairn', code: 'PN'},
    {name: 'Poland', code: 'PL'},
    {name: 'Portugal', code: 'PT'},
    {name: 'Puerto Rico', code: 'PR'},
    {name: 'Qatar', code: 'QA'},
    {name: 'Reunion', code: 'RE'},
    {name: 'Romania', code: 'RO'},
    {name: 'Russian Federation', code: 'RU'},
    {name: 'RWANDA', code: 'RW'},
    {name: 'Saint Helena', code: 'SH'},
    {name: 'Saint Kitts and Nevis', code: 'KN'},
    {name: 'Saint Lucia', code: 'LC'},
    {name: 'Saint Pierre and Miquelon', code: 'PM'},
    {name: 'Saint Vincent and the Grenadines', code: 'VC'},
    {name: 'Samoa', code: 'WS'},
    {name: 'San Marino', code: 'SM'},
    {name: 'Sao Tome and Principe', code: 'ST'},
    {name: 'Saudi Arabia', code: 'SA'},
    {name: 'Senegal', code: 'SN'},
    {name: 'Serbia and Montenegro', code: 'CS'},
    {name: 'Seychelles', code: 'SC'},
    {name: 'Sierra Leone', code: 'SL'},
    {name: 'Singapore', code: 'SG'},
    {name: 'Slovakia', code: 'SK'},
    {name: 'Slovenia', code: 'SI'},
    {name: 'Solomon Islands', code: 'SB'},
    {name: 'Somalia', code: 'SO'},
    {name: 'South Africa', code: 'ZA'},
    {name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
    {name: 'Spain', code: 'ES'},
    {name: 'Sri Lanka', code: 'LK'},
    {name: 'Sudan', code: 'SD'},
    {name: 'Suriname', code: 'SR'},
    {name: 'Svalbard and Jan Mayen', code: 'SJ'},
    {name: 'Swaziland', code: 'SZ'},
    {name: 'Sweden', code: 'SE'},
    {name: 'Switzerland', code: 'CH'},
    {name: 'Syrian Arab Republic', code: 'SY'},
    {name: 'Taiwan, Province of China', code: 'TW'},
    {name: 'Tajikistan', code: 'TJ'},
    {name: 'Tanzania, United Republic of', code: 'TZ'},
    {name: 'Thailand', code: 'TH'},
    {name: 'Timor-Leste', code: 'TL'},
    {name: 'Togo', code: 'TG'},
    {name: 'Tokelau', code: 'TK'},
    {name: 'Tonga', code: 'TO'},
    {name: 'Trinidad and Tobago', code: 'TT'},
    {name: 'Tunisia', code: 'TN'},
    {name: 'Turkey', code: 'TR'},
    {name: 'Turkmenistan', code: 'TM'},
    {name: 'Turks and Caicos Islands', code: 'TC'},
    {name: 'Tuvalu', code: 'TV'},
    {name: 'Uganda', code: 'UG'},
    {name: 'Ukraine', code: 'UA'},
    {name: 'United Arab Emirates', code: 'AE'},
    {name: 'United Kingdom', code: 'GB'},
    {name: 'United States', code: 'US'},
    {name: 'United States Minor Outlying Islands', code: 'UM'},
    {name: 'Uruguay', code: 'UY'},
    {name: 'Uzbekistan', code: 'UZ'},
    {name: 'Vanuatu', code: 'VU'},
    {name: 'Venezuela', code: 'VE'},
    {name: 'Viet Nam', code: 'VN'},
    {name: 'Virgin Islands, British', code: 'VG'},
    {name: 'Virgin Islands, U.S.', code: 'VI'},
    {name: 'Wallis and Futuna', code: 'WF'},
    {name: 'Western Sahara', code: 'EH'},
    {name: 'Yemen', code: 'YE'},
    {name: 'Zambia', code: 'ZM'},
    {name: 'Zimbabwe', code: 'ZW'}
]

export const telephoneCodes = ['+94', '+93', '+35818', '+1684', '+61', '+880', '+1', '+86']

export const BROWSERS = {
    firefox: 'Firefox',
    chrome: 'Chrome',
    safari: 'Safari',
    opera: 'Opera',
    edge: 'Edge',
    internetExplorer: 'Internet Explorer'
}

export const STUDENT_TYPES = [
    {label: 'Registered', value: 'REGISTERED'},
    {label: 'Inquiry', value: 'INQUIRY'}
]

export const EXPORT_TYPES = {
    CURRENT: 'CURRENT',
    ALL: 'ALL',
    CUSTOM: 'CUSTOM'
}

export const EXPORT_SIZES = [
    {label: '50', value: 50},
    {label: '100', value: 100},
    {label: '250', value: 250},
    {label: '500', value: 500},
    {label: '1000', value: 1000}
]

export const EXPORT_FORMATS = [
    {label: 'CSV', value: 'CSV'},
    {label: 'XLSX', value: 'XLSX'}
]

export const CHANGE_MODULES_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Student Name", key: "studentName"},
    {label: basicInfo.courseLabel, key: "courseName"},
    {label: "Level", key: "levelName"},
    {label: "Batch", key: "batchCode"},
    {label: "Branch", key: "branchName"},
    {label: "Intake", key: "intakeCode"}
]

export const MS_LOGIN_TYPES = {
    STAFF: 'STAFF',
    STUDENT: 'STUDENT'
}

export const DASHBOARD_TARGET_TYPES = {
    INDIVIDUAL: 'INDIVIDUAL',
    GROUP: 'GROUP'
}

export const EMAIL_STATUS = [
    // {label: 'Pending', value: 'PENDING'},
    // {label: 'Deferred', value: 'DEFERRED'},
    {label: 'Delivered', value: 'DELIVERED'},
    {label: 'Bounced', value: 'BOUNCED'}
]

export const EMAIL_SUBJECTS = [
    {label: 'Offer letter', value: 'OFFER_LETTER'},
    {label: 'Confirmation link', value: 'CONFIRMATION_LINK'},
    {label: 'Course details', value: 'COURSE_DETAILS'},
    {label: 'Invoice', value: 'INVOICE'}
]

export const DEGREE_STATUS = [
    {label: 'Under Graduate', value: 'UNDERGRADUATE'},
    {label: 'Post Graduate', value: 'POSTGRADUATE'}
]

export const ACTIVE_STUDENT_CSV_HEADER = [
    {label: basicInfo.regText, key: "cbNumber"},
    {label: "Student Name", key: "studentName"},
    {label: "Address", key: "address"},
    {label: "Contact", key: "studentMobile"},
    {label: "Personal Email", key: "personalEmail"},
    {label: "Batch Code", key: "batchCode"},
    {label: "NIC", key: "nic"}
]

export const ACCEPTANCE_LETTER_STATUS = [
    {label: 'All', value: null},
    {label: 'Approved', value: 'APPROVED'},
    {label: 'Rejected', value: 'REJECTED'}
]

export const DEFAULT_SMP_ROUTES = [config.librarianRole, config.industryRole, config.studentSupportServiceRole]

export const GAP_VIEW_STUDENTS_CSV_HEADER = [
    {label: "regNo", key: "cbNumber"},
    {label: "studentName", key: "studentName"},
    {label: "studentEmail", key: "studentEmail"},
    {label: "studentMobile", key: "studentMobile"},
    {label: "batchCode", key: "batchCode"},
    {label: `${basicInfo.courseLabel} Name`, key: "courseName"},
    {label: `${basicInfo.courseLabel} Code`, key: "courseCode"}
]

export const GAP_SLOT_STUDENTS_EXPORT_CSV_HEADER = [
    {label: basicInfo.regText, key: "regNo"},
    {label: "Student Name", key: "studentName"},
    {label: "Student Email", key: "studentEmail"},
    {label: "Student Mobile", key: "studentMobile"},
    {label: "Course Name", key: "courseName"},
    {label: "Course Code", key: "courseCode"},
    {label: "Batch Code", key: "batchCode"}
]